




















import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'FilesSearch'
})
export default class extends Vue {
}
